import { screenVersions } from './screen-versions.js';

// Content versions allow long caching without retaining an old screen upload.
export function screenAsset(url) {
  const path = url.split('?')[0];
  return screenVersions[path] ? screenVersions[path] : url;
}
